import styled from 'styled-components';

import Msg from 'components/Message';

export const Message = styled(Msg)`
  margin-top: -10px;
`;
